import { useEffect, useState } from "react";
import { CommentModel } from "@/types";

const Comment = ({ name, message, backgroundColor, originalLanguage }: CommentModel) => {
  const [color, setColor] = useState("none");
  const [textShadow, setTextShadow] = useState("");
  
  const getLanguageLabel = (lang?: string) => {
    if (!lang) return null;
    switch (lang.toLowerCase()) {
      case "ja":
      case "japanese":
        return { text: "日", bgColor: "tw-bg-red-500/80" };
      case "zh":
      case "chinese":
        return { text: "中", bgColor: "tw-bg-yellow-500/80" };
      case "en":
      case "english":
        return { text: "E", bgColor: "tw-bg-blue-500/80" };
      default:
        return null;
    }
  };
  
  useEffect(() => {
    switch (backgroundColor) {
      case "none":
        setColor("tw-bg-transparent tw-text-white");
        setTextShadow('1px 1px 2px rgba(64, 64, 64, 0.7), -1px -1px 2px rgba(64, 64, 64, 0.7), 1px -1px 2px rgba(64, 64, 64, 0.7), -1px 1px 2px rgba(64, 64, 64, 0.7)');
        break;
      case "orange":
        setColor("tw-bg-orange-500/40 tw-text-white");
        setTextShadow('1px 1px 2px rgba(64, 64, 64, 0.7), -1px -1px 2px rgba(64, 64, 64, 0.7), 1px -1px 2px rgba(64, 64, 64, 0.7), -1px 1px 2px rgba(64, 64, 64, 0.7)');
        break;
      case "green":
        setColor("tw-bg-green-600/40 tw-text-white");
        setTextShadow('1px 1px 2px rgba(64, 64, 64, 0.7), -1px -1px 2px rgba(64, 64, 64, 0.7), 1px -1px 2px rgba(64, 64, 64, 0.7), -1px 1px 2px rgba(64, 64, 64, 0.7)');
        break;
      case "white":
        setColor("tw-bg-white/40 tw-text-gray-800");
        setTextShadow('1px 1px 2px rgba(255, 255, 255, 0.8), -1px -1px 2px rgba(255, 255, 255, 0.8), 1px -1px 2px rgba(255, 255, 255, 0.8), -1px 1px 2px rgba(255, 255, 255, 0.8)');
        break;
      default:
        setColor("tw-bg-transparent");
        setTextShadow('1px 1px 2px rgba(64, 64, 64, 0.7), -1px -1px 2px rgba(64, 64, 64, 0.7), 1px -1px 2px rgba(64, 64, 64, 0.7), -1px 1px 2px rgba(64, 64, 64, 0.7)');
    }
  }, [message, backgroundColor]);
  const languageLabel = getLanguageLabel(originalLanguage);
  
  return (
    <div role="listitem" aria-label="comment">
      <div
        className="tw-text-sm tw-text-white tw-drop-shadow tw-text-left tw-font-bold tw-flex tw-items-center tw-gap-1"
        style={{ textShadow }}
        role="presentation"
        aria-label="comment name"
      >
        {name}
        {languageLabel && (
          <span className={`tw-inline-block ${languageLabel.bgColor} tw-text-white tw-text-xs tw-px-1.5 tw-py-0.5 tw-rounded tw-font-bold`}>
            {languageLabel.text}
          </span>
        )}
      </div>
      <div
        className={`${color} tw-px-2 tw-py-1 tw-rounded tw-drop-shadow tw-whitespace-pre-wrap tw-text-sm tw-text-left`}
        style={{ textShadow }}
        role="presentation"
        aria-label="comment message"
      >
        {message}
      </div>
    </div>
  );
};
export default Comment;
